import React from 'react'
import _ from 'underscore'
import moment from 'moment'

class Datetime extends React.Component {

  render() {
    if (_.isEmpty(this.props.date)) {
      return null
    }

    const formatted = moment(this.props.date).format("llll")

    return (
      <span>{formatted}</span>
    )
  }
}
    
export default Datetime